module.exports = __webpack_public_path__ + "img/logo-black.795d7197.png";